import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { throwError, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
const baseApiTalkphr = environment.baseApiIpTalkPhr;
@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private genericService: GenericUtilityService, private http: HttpClient) { }

  getPaymentDetails(practice_code: any,patient_Account:any,appointmentId:any){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/GetPatientAmountDue?PatientAccount=" + patient_Account + '&PracticeCode=' + practice_code + '&AppointmentId=' + appointmentId);
  }
  getPaymentDetailsOld(practice_code: any, patient_Account: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/GetPatientAmountDueOld?PatientAccount=" + patient_Account + '&PracticeCode=' + practice_code);

  }
  //https://uat-webservices.mtbc.com/breezeCheckinApi/api/TalkCheckinPhaseTwo/GetPatientAmountDueOld?PatientAccount=10111639286926205&PracticeCode=1011163%27
  getPracticeDetails(practice_code : any,patient_Account : any){
    return this.genericService.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/DashBoardPracticeInfo?PatientAccount=" + patient_Account + '&PracticeCode=' + practice_code);
  }
  getExistingCreditCradDetails(practice_code: any, patient_Account: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/GetExistingCardsInfo?PatientAccount=" + patient_Account + '&PracticeCode=' + practice_code);
    //return '{"statusCode": 200,"message": "Success","data": [    {        "crediT_CARD_ID": "5652759",        "tokeN_NUMBER": "4111113206621111",        "expiratioN_MONTH": "5",        "expiratioN_YEAR": "2025",        "carD_TYPE": "Visa"    },    {        "crediT_CARD_ID": "5652758",        "tokeN_NUMBER": "4111113206621111",        "expiratioN_MONTH": "5",        "expiratioN_YEAR": "2025",        "carD_TYPE": "Visa"    }]}'
  }
  getPaymentSettings(data: any){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "GetPaymentSettings?PracticeCode="+data.PracticeCode+'&PatientAccount='+data.PatientAccount, null);
  }


  submitPayment(data: any){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "OnlinePaymentV4", data);
  }
  submitPaymentNew(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "OnlinePaymentV5", data);
  }
  OnlinePaymentSaveCard(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "OnlinePaymentSaveCard", data);
  }
  

  sendEmailReceipt(data: any){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "EmailPaymentReceipt", data);
  }

  sendSMS(data: any){
    return this.genericService.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "SendSMSPaymentDetails", data);
  }

  //  https://localhost:64220/api/TalkCheckinPhaseTwo/DeleteCreditCardInfo?PatientAccount=1011163565412546&PracticeCode=1011163&CreditCardId=5652758%27

  //delete credit card post request
  token: any = "";
  private apiUrl = baseApiTalkphr + 'api/TalkCheckinPhaseTwo/DeleteCreditCardInfo';
  deleteCreditCardInfo(practice_code: any, patient_Account: any,creditcardId:any): Observable<any> {

    const url = `${this.apiUrl}?PatientAccount=${patient_Account}&PracticeCode=${practice_code}&CreditCardId=${creditcardId}`;
    this.token = localStorage.getItem("AuthTokenwebServices");
    if (!this.token || this.token == '' || this.token == undefined) {

      this.token = sessionStorage.getItem("AuthTokenwebServices");
      console.log("Getting token from ss GET " + this.token);
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Authorization': "Bearer " + this.token,
    });


    return this.http.post<any>(url, {}, { headers });

  }

  encryptStringAngular(dto: any){
    return this.genericService.ApiPostMethodTalkphrEncDec("EncDec", "EncryptString_Angular", dto);
  }

  getCityStateViaZip(zipcode: string, PATIENT_ACCOUNT: any, PRACTICE_CODE: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckinPhaseTwo/ZipCityState?PracticeCode=" + PRACTICE_CODE + '&PatientAccount=' + PATIENT_ACCOUNT + '&ZipCode=' + zipcode);
  }
}
